import { Button, Modal, Text, TextInput, TouchableOpacity, View, Image, Pressable } from "react-native";
import React, { useState } from "react";
import { StyleSheet } from "react-native";
import { Icons } from "../../assets";
import { useGlobalState } from "../../shared/state";
import Auth from "../Buttons/auth-button/Auth";
import Logo from "./Logo";
import CircleButton from "../Buttons/generic-button/CircleButton";
import { Carts } from "../../shared/model/types";
import { useNavigation } from "@react-navigation/native";

type Props = {
  closeButton?: boolean;
  logo?: boolean;
  hideInfoButton?: boolean;
  hideBackButton?: boolean;
};

const Header = ({ closeButton, logo, hideInfoButton, hideBackButton }: Props): JSX.Element => {
  const [currentScanner] = useGlobalState("currentScanner");
  const [Colors] = useGlobalState("colors");
  const [carts] = useGlobalState("carts");
  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigation = useNavigation();

  const isBirkenstock = currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock";

  function getTotalItemsInCart(carts: Carts): number {
    let totalItems = 0;

    for (const cartId in carts) {
      const cart = carts[cartId];
      if (cart.items) {
        totalItems += cart.items.length;
      }
    }

    return totalItems;
  }

  const SECRET = "1234"; // not secure

  const handleSubmit = () => {
    if (password === SECRET) {
      setVisible(false);
      setPassword("");
      navigation.push("System");
    } else {
      setError("Incorrect password");
    }
  };

  let closeButtonColor: string;
  if (currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock") {
    closeButtonColor = "#0e2288";
  } else {
    closeButtonColor = Colors.mainColorDark.color;
  }
  let closeButtonIcon: any;
  if (currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock") {
    closeButtonIcon = Icons.backArrowFilledIcon;
  } else {
    closeButtonIcon = Icons.closeIconTransparent;
  }

  let infoButtonColor: string;
  if (currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "onefid") {
    infoButtonColor = Colors.white.color;
  } else if (currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock") {
    infoButtonColor = "#0e2288";
  } else {
    infoButtonColor = Colors.mainColorDark.color;
  }

  let infoButtonIcon: string;
  if (currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "onefid") {
    infoButtonIcon = Icons.infoIconBlack;
  } else if (currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock") {
    infoButtonIcon = Icons.infoIconWhite;
  } else {
    infoButtonIcon = Icons.infoIconWhite;
  }

  return (
    <View style={styles.header}>
      <View style={styles.mainContainer}>
        <View style={styles.leftContainer}>
          <View style={styles.centeredContent}>
            {isBirkenstock && !hideInfoButton ? (
              <TouchableOpacity
                // onPress={() => setVisible(true)}
                onPress={() => navigation.push("System")}
                style={{ height: "100%", width: "100%", backgroundColor: "#0e2288", borderRadius: 15, justifyContent: "center", alignItems: "center" }}
              >
                <Image
                  source={Icons.infoIconBirkenstock}
                  style={{
                    alignContent: "center",
                    resizeMode: "contain",
                    width: "50%",
                    height: "50%",
                  }}
                />
              </TouchableOpacity>
            ) : isBirkenstock && !hideBackButton ? (
              <CircleButton color="#0e2288" navigateTo="goBack" icon={Icons.backArrowFilledIcon} deactivated={currentScanner ? false : true} />
            ) : null}
            {currentScanner &&
              !isBirkenstock &&
              (closeButton ? (
                <CircleButton color={closeButtonColor} navigateTo="CloseButton" icon={closeButtonIcon} deactivated={currentScanner ? false : true} />
              ) : (
                <CircleButton
                  color={infoButtonColor}
                  navigateTo="Support"
                  icon={currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "onefid" ? Icons.infoIconBlack : Icons.infoIconWhite}
                  deactivated={currentScanner ? false : true}
                />
              ))}
          </View>
        </View>
        {currentScanner && !isBirkenstock && (
          <View style={styles.rightContainer}>
            <View style={styles.centeredContent}>
              <Auth />
            </View>
          </View>
        )}
        <Modal
          animationType="slide"
          transparent
          visible={visible}
          onRequestClose={() => {
            setVisible(!visible);
          }}
        >
          <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
            <View style={{ backgroundColor: "white", padding: 20, width: "15%", height: "25%", borderRadius: 10, display: "flex", flexDirection: "column", justifyContent: "space-evenly", alignItems: "center" }}>
              <View style={{ width: "80%", height: "40%" }}><Text>Enter password</Text>
              <TextInput secureTextEntry value={password} onChangeText={setPassword} style={{backgroundColor: "#dedfe3", height: "55%", marginTop: 10, marginBottom: 10}}/>
              {error ? <Text style={{ color: "red" }}>{error}</Text> : null}</View>
              <View style={{ width: "100%", height: "35%", flexDirection: "row", justifyContent: "space-evenly", alignItems: "center" }}>
                <Pressable onPress={handleSubmit} style={[styles.button, {backgroundColor: "#0e2288"}]}>
                  <Text style={[styles.textStyle, {color: "white"}]}>Submit</Text>
                </Pressable>
                <Pressable onPress={() => setVisible(false)} style={[styles.button, {backgroundColor: "#dedfe3"}]}>
                  <Text style={[styles.textStyle, {color: "#0e2288"}]}>Close</Text>
                </Pressable>
              </View>
            </View>
          </View>
        </Modal>
        {currentScanner && currentScanner.enableOrder && (
          <View style={styles.rightContainer}>
            <View style={styles.centeredContent}>
              <View style={[styles.notification, { backgroundColor: Colors.mainColorLight.color }]}>
                <p style={{ color: "white" }}>{getTotalItemsInCart(carts)}</p>
              </View>
              <CircleButton
                color={closeButtonColor}
                navigateTo="CartModal"
                icon={currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "onefid" ? Icons.cartBlack : Icons.cartWhite}
                deactivated={false}
              />
            </View>
          </View>
        )}
      </View>
      <View style={styles.logo}>{logo ? <Logo /> : <View />}</View>
    </View>
  );
};

export default Header;

const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: "row",
    width: "11%",
    height: "100%",
    alignItems: "center",
  },
  leftContainer: {
    width: "50%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  rightContainer: {
    width: "50%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  centeredContent: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  header: {
    height: "15%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "transparent",
    padding: "1%",
  },
  logo: {
    width: "30%",
    height: "100%",
    alignItems: "flex-end",
    alignContent: "flex-end",
    justifyContent: "center",
  },
  notification: {
    width: 25,
    height: 25,
    borderRadius: 10,
    top: 45,
    position: "fixed",
    zIndex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
    width: "45%",
    height: "90%",
    justifyContent: "center",
  },
  textStyle: {
    fontWeight: "bold",
    textAlign: "center",
  },
});
